<template>
  <div class="p-2 p-x-4:d">
    <div class="text-large c-gray60" v-if="reviews.length">REVIEWS</div>
    <div class="d-flex flex-1-1 fd-column fd-row:d" v-if="reviews.length">
      <div class="flex-1-1 fd-column">
        <span class="text-bold"> Overall Ratings </span>
        <reviews-header
            class="m-r-1"
            v-if="combineMeta.aggregation"
            v-bind="combineMeta"
            @percentage-bar="filterHeaderRating"
        />
      </div>
      <div class="flex-2-1 fd-column m-r-1">
        <span
            v-if="aggregation.category_rating
              && aggregation.category_rating.knowledge_average_rating !== 'NaN'
            && aggregation.category_rating.responsiveness_average_rating !== 'NaN'"
            class="text-bold"> Attribute Ratings</span>
        <review-categories
            v-if="aggregation.category_rating"
            :categories="aggregation.category_rating"
        />
      </div>
    </div>
    <div v-if="reviews.length" class="m-y-2" id="SORT-BY">
      <div class="text-bold p-t-2 bd-t-gray40 c-gray80">
        {{ reviewCount }} verified reviews
      </div>
      <div class="SORTANDFILTER">
        <div class="SORT flex-1-1 m-r-4:t">
          <div class="text-md c-gray70 p-b-1">Sort By</div>
          <select-box
              v-model="sorting"
              :options="$options.SORTKEYS"
              option-label="label"
              option-value="key"/>
        </div>

        <div v-if="rating" :class="{'FILTERBAR':!$device.isMobile && rating}" class="p-l-4:d FILTERBAR flex-1-1">
          <div class="c-gray70 p-b-1 d-none:mo">&nbsp;</div>
          <div class="m-t-2:mo">
            <filter-pill
                class="BUTTON-GROUP m-l-1 m-y-1"
                :label="` ${rating} ${rating > 1 ? 'stars' : 'star'}`"
                @click="removeFilter()"/>
          </div>
        </div>
      </div>


    </div>
    <div
        v-for="(review, index) in reviews"
        :key="index"
        class="text-md bd-t-gray40"
        v-if="reviews.length">
      <review-with-pics :review="review" />
    </div>
    <div
        v-if="showMoreReviews && !loadingReview"
        class="d-flex flex-center c-bgray m-y-2"
        @click="showMore">Show more review</div>
    <div class="d-flex flex-center">
      <spinner v-if="loadingReview" />
    </div>
  </div>
</template>

<script>
import { getReviews } from '@homeservices/api-kit/search/reviews/v1';

import ReviewsHeader from '@/components/Reviews/ReviewsHeader';
import ReviewCategories from '@/components/ReviewCategories';
import ReviewWithPics from '@/components/Reviews/ReviewWithPics';
import SelectBox from '@/components/SelectBox';
import { keys } from '@/constants/reviewSortKeys';
import FilterPill from '@/components/FilterPill';
import Review from './Review';

const REVIEW_SIZE = 10;

export default {
  SORTKEYS: keys,
  name: 'pro-reviews',
  components: {
    Review,
    ReviewsHeader,
    ReviewCategories,
    ReviewWithPics,
    SelectBox,
    FilterPill,
  },
  props: {
    publicProfile: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      aggregation: {},
      reviews: [],
      reviewCount: 0,
      reviewFrom: 0,
      loadingReview: false,
      sorting: 'created_dtm desc',
      rating: null,
      combineMeta: {},
      scrollToSort: false,
    };
  },
  computed: {
    showMoreReviews () {
      return this.reviewCount > this.reviews.length;
    },
  },
  watch: {
    sorting: {
      immediate: true,
      handler (newVal, oldVal) {
        this.scrollToSort = !!oldVal;
        this.resetReview();
        this.fetchReviews();
      },
    },
  },
  beforeDestroy () {
    this.resetReview();
  },
  methods: {
    scrollToSortBy () {
      if (this.scrollToSort) {
        setTimeout(() => {
          const container = this.$el.querySelector('#SORT-BY');
          container.scrollIntoView({ behavior: 'smooth' });
        }, 0);
      }
    },
    showMore () {
      this.scrollToSort = false;
      this.fetchReviews();
    },
    fetchReviews () {
      this.loadingReview = true;
      getReviews({
        rating: this.rating,
        from: this.reviewFrom,
        size: REVIEW_SIZE,
        service_provider_id: this.publicProfile.service_provider.id,
        occupation_id: this.publicProfile.occupation_id,
        sorting: this.sorting,
      })
        .then(({ data }) => {
          this.setCombineMeta(data);
          this.reviewFrom += REVIEW_SIZE;
          this.loadingReview = false;
          this.reviewCount = data.total;
          this.reviews = this.reviews.concat(data.results);
          this.scrollToSortBy();
        })
        .catch(() => {
          this.loadingReview = false;
        });
    },
    setCombineMeta (data) {
      if (!Object.keys(this.combineMeta).length) {
        this.combineMeta = {
          aggregation: data.aggregation,
          total: data.total,
          from: 0,
          length: data.count,
        };
      }
    },
    filterHeaderRating (evt) {
      this.resetReview();
      this.rating = evt;
      this.fetchReviews();
      this.scrollToSort = true;
    },
    removeFilter () {
      this.rating = null;
      this.resetReview();
      this.fetchReviews(0);
    },

    resetReview () {
      this.reviews = [];
      this.reviewFrom = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
    .SORTANDFILTER {
      @include tablet {
        display: flex;
      }
    }
      .SORT{
      @include tablet {
        max-width: 340px;
      }
    }
    .FILTERBAR{
      @include tablet {
        border-left: 1px solid $color-gray40;
      }
    }
</style>
